import disabledEmphasis from '../../../../text/disabled-emphasis';

const dark = (params) => disabledEmphasis(params);

export default dark;
